import { Component, OnInit } from '@angular/core';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { element } from '@angular/core/src/render3/instructions';

@Component({
  selector: 'app-tour-prog-rep',
  templateUrl: './tour-prog-rep.component.html',
  styleUrls: ['./tour-prog-rep.component.css']
})
export class TourProgRepComponent implements OnInit {

  public menu_item_id = '113';
  public add_auth;
  public edit_auth;
  public del_auth;

  cat_list = [];
  prog_list = [];

  active_list = [{ 'status_id': '1', 'status_name': 'الرحلات النشطة', 'status_name_en': 'Ingoing Programs' },
    { 'status_id': '0', 'status_name': 'الرحلات المؤرشفة', 'status_name_en': 'Archived Programs' }];

  model = {
    'table_name': 'trip', 'category_id': '0', 'active': '1', 'title': 'كشوف البرامج السياحية'
  };

  Tourist_Programs_Report; Category_Msg; Prog_Category; View;
  html_data = '';

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) { 
      this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Tourist_Programs_Report').subscribe((res: string) => {
      this.Tourist_Programs_Report = res;
    });
    this.model['title'] = this.Tourist_Programs_Report;
    
    translate.get('Category_Msg').subscribe((res: string) => {
      this.Category_Msg = res;
    });

    translate.get('Prog_Category').subscribe((res: string) => {
      this.Prog_Category = res;
    });

    translate.get('View').subscribe((res: string) => {
      this.View = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT * FROM `category` WHERE `status` = '1'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.cat_list = data.data['list'];
        this.cat_list.unshift({ 'category_id': '0', 'category_name': 'اختر', 'category_name_en': 'Select' });
      });
  }

  view() {
    if (this.model['category_id'] == '0') {
      alert(this.Category_Msg);
      return;
    }

    let obj = { cmd: 'getTripReport' };

    if (this.model['category_id'] != '0')
      obj['category_id'] = this.model['category_id'];

    obj['active'] = this.model['active'];

    this.utils.invokeHttp(this.applicationConstants.tourismFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.prog_list = data.data['list'];

        // prepare html data for printing the report
        this.html_data = '<table cellpadding="8" cellspacing="0">';
        this.html_data += '<tr><td width="50%"> ' + this.Prog_Category + ": ";
        this.cat_list.forEach(element => {
          if (element.category_id == this.model['category_id'])
            this.html_data += (this.applicationConstants.user_lang == "en" ? element.category_name_en : element.category_name)  + '</td>';
        });

        this.html_data += '<td width="50%"> ' + this.View + ": ";
        this.active_list.forEach(element => {
          if (element.status_id == this.model['active'])
            this.html_data += (this.applicationConstants.user_lang == "en" ? element.status_name_en : element.status_name)  + '</td></tr>';
        });
        this.html_data += '</table>';

        let col_list = [];
        let trip_city = [];
        let trip_city_hotel = [];
        let hotel_name, hotel_name_en;

        this.prog_list.forEach(element => {
          element.row_list = [];
          col_list = [];
          trip_city = element.trip_city;

          this.html_data += '<h4></h4><table border="1" width="100%" cellpadding="5" cellspacing="0">';

          // fill frist row
          col_list.push({ name_ar: 'رقم البرنامج', name_en: 'Program Number' });
          this.html_data += '<tr><td style="text-align: center;">' + 
            (this.applicationConstants.user_lang == "en" ? 'Program Number' : 'رقم البرنامج')  + '</td>';

          col_list.push({ name_ar: 'الذهاب', name_en: 'Depart' });
          this.html_data += '<td style="text-align: center;">' + 
            (this.applicationConstants.user_lang == "en" ? 'Depart' : 'الذهاب')  + '</td>';

          // city name
          trip_city.forEach(city => {
            col_list.push({ name_ar: city.city_name, name_en: city.city_name_en });
            this.html_data += '<td style="text-align: center;">' + 
              (this.applicationConstants.user_lang == "en" ? city.city_name_en : city.city_name)  + '</td>';
          });

          col_list.push({ name_ar: 'العودة', name_en: 'Arrival' });
          this.html_data += '<td style="text-align: center;">' + 
            (this.applicationConstants.user_lang == "en" ? 'Arrival' : 'العودة')  + '</td>';

          col_list.push({ name_ar: element.nights_num + ' ليال' + ' - ' + element.days_number + ' أيام', 
            name_en: element.nights_num + ' Nights' + ' - ' + element.days_number + ' Days' });

          this.html_data += '<td style="text-align: center;">' + element.nights_num + 
            (this.applicationConstants.user_lang == "en" ? ' Nights' : ' ليال')  + '<br/>' + 
            element.days_number + (this.applicationConstants.user_lang == "en" ? ' Days' : ' أيام') + '</td></tr>';

          element.row_list.push({ col_list: col_list });

          // fill second row
          col_list = [];
          col_list.push({ name_ar: element.trip_name + ' - ' + element.trip_number, 
            name_en: element.trip_name + ' - ' + element.trip_number });
          this.html_data += '<tr><td style="text-align: center;">' + element.trip_name  + '<br/>' +
            element.trip_number  + '</td>';

          col_list.push({ name_ar: element.departure_date, name_en: element.departure_date });
          this.html_data += '<td style="text-align: center;">' + element.departure_date  + '</td>';

          // hotel name
          trip_city.forEach(city => {
            trip_city_hotel = city.trip_city_hotel;
            hotel_name = '';
            hotel_name_en = '';

            trip_city_hotel.forEach(hotel => {
              if (hotel_name != '')
                hotel_name += ' - ';

              if (hotel_name_en != '')
                hotel_name_en += ' - ';

              hotel_name += hotel.hotel_name;
              hotel_name_en += hotel.hotel_name_en;
            });

            col_list.push({ name_ar: hotel_name, name_en: hotel_name_en });
            this.html_data += '<td style="text-align: center;">' + 
              (this.applicationConstants.user_lang == "en" ? hotel_name_en : hotel_name)  + '</td>';
          });

          col_list.push({ name_ar: element.arrival_date, name_en: element.arrival_date });
          this.html_data += '<td style="text-align: center;">' + element.arrival_date  + '</td>';

          col_list.push({ name_ar: element.trip_price, name_en: element.trip_price });
          this.html_data += '<td style="text-align: center;">' + element.trip_price  + '</td></tr>';

          element.row_list.push({ col_list: col_list });

          // fill third row
          col_list = [];
          col_list.push({ name_ar: 'ساعة الإنطلاق', name_en: 'Depart Time' });
          this.html_data += '<tr><td style="text-align: center;">' + 
            (this.applicationConstants.user_lang == "en" ? 'Depart Time' : 'ساعة الإنطلاق')  + '</td>';

          col_list.push({ name_ar: element.depart_day_ar, name_en: element.depart_day });
          this.html_data += '<td style="text-align: center;">' + 
              (this.applicationConstants.user_lang == "en" ? element.depart_day : element.depart_day_ar)  + '</td>';

          // city nights and days
          trip_city.forEach(city => {
            col_list.push({ name_ar: city.nights_num + ' ليال' + ' - ' + city.days_num + ' أيام', 
              name_en: city.nights_num + ' Nights' + ' - ' + city.days_num + ' Days' });

            this.html_data += '<td style="text-align: center;">' + city.nights_num + 
              (this.applicationConstants.user_lang == "en" ? ' Nights' : ' ليال')  + '<br/>' + 
              city.days_num + (this.applicationConstants.user_lang == "en" ? ' Days' : ' أيام') + '</td>';
          });

          col_list.push({ name_ar: element.arrival_day_ar, name_en: element.arrival_day });
          this.html_data += '<td style="text-align: center;">' + 
              (this.applicationConstants.user_lang == "en" ? element.arrival_day : element.arrival_day_ar) + '</td>';

          col_list.push({ name_ar: 'ساعة العودة', name_en: 'Arrival Time' });
          this.html_data += '<td style="text-align: center;">' + 
            (this.applicationConstants.user_lang == "en" ? 'Arrival Time' : 'ساعة العودة')  + '</td></tr>';

          element.row_list.push({ col_list: col_list });

          // fill fourth row
          col_list = [];
          col_list.push({ name_ar: element.departure_time, name_en: element.departure_time });
          this.html_data += '<tr><td style="text-align: center;">' + element.departure_time + '</td>';

          col_list.push({ name_ar: element.hijri_departure_date, name_en: element.hijri_departure_date });
          this.html_data += '<td style="text-align: center;">' + element.hijri_departure_date + '</td>';

          // city nights and days
          trip_city.forEach(city => {
            col_list.push({ name_ar: city.arrival_date + ' / ' + city.depart_date, 
            name_en: city.arrival_date + ' / ' + city.depart_date });

            this.html_data += '<td style="text-align: center;">' + city.arrival_date + '<br/>' + city.depart_date + '</td>';
          });

          col_list.push({ name_ar: element.hijri_arrival_date, name_en: element.hijri_arrival_date });
          this.html_data += '<td style="text-align: center;">' + element.hijri_arrival_date + '</td>';

          col_list.push({ name_ar: element.arrival_time, name_en: element.arrival_time });
          this.html_data += '<td style="text-align: center;">' + element.arrival_time + '</td></tr>';

          element.row_list.push({ col_list: col_list });
          this.html_data += '</table>';
        });
      });
  }

  print() {
    let form = (document.getElementById('form1') as HTMLFormElement);
    this.html_data += this.utils.printReport(this.html_data, [], form, 'PDF');
  }

}
